import React, { useEffect, useState } from 'react';
import { Route, RouteProps } from 'react-router-dom';
import { useKeycloak } from '@react-keycloak/web';
import AuthService from '../../../services/auth/Auth.services';
import LocalStorageWrapper from '../../../core/wrappers/browserStorage/localStorage-wrapper';
import Helper from '../../../utils/helper';

interface IProps {
    Component: React.ComponentType<any>;
    path: string;
    exact?: boolean;
}

const hasValidStoredToken = () => {
    const token = localStorage.getItem('access_token');
    const exp = localStorage.getItem('token_expires');
    if (!token || !exp) return false;
    return Date.now() < Number(exp) - 30_000;
};

export const AuthenticatedRoute: React.FC<IProps> = ({ Component, ...rest }) => {
    const { initialized } = useKeycloak();
    const [isLoading, setIsLoading] = useState(true);
    const [isAuthenticated, setIsAuthenticated] = useState(false);

    useEffect(() => {
        if (!initialized) return;

        const authService = new AuthService();

        const checkAuthentication = async () => {
            try {
                if (hasValidStoredToken()) {
                    setIsAuthenticated(true);
                    setIsLoading(false);
                    return;
                }

                let returnPath = window.location.pathname;
                if (!Helper.isNil(window.location.search)) {
                    returnPath += window.location.search;
                }
                LocalStorageWrapper.setItemToLocalStorage('returnPath', returnPath);
                authService.login();
            } catch (error) {
                console.error('Auth check failed:', error);
                setIsAuthenticated(false);
                setIsLoading(false);
            }
        };

        checkAuthentication();
    }, [initialized]);

    if (!initialized || isLoading) {
        return (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
                <div className="loading-spinner"></div>
            </div>
        );
    }

    const routeProps: RouteProps = {
        ...rest,
        render: (props) => (isAuthenticated ? <Component {...props} /> : null),
    };

    return <Route {...routeProps} />;
};

export default AuthenticatedRoute;
